export const ADMIN_ADDRESS = "HBVMuFWLFGGxLUcGs77a1zzgxNUiLDZTvhzSoWKjioJK";
export const PROJECT_VAULT_ADDRESS = "htK8KQAsaTn5KMF5SDnPTuw3PpTeCRLZVY7ecSjBzZ2";
export const SOL = "solana";
export const USDC = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const COINS_PER_RACE = "5";
export const LOTTERY_DURATION_SEC = "30";
export const RACE_DURATION_SEC = "780";
export const POINTS_PER_WIN = "100";
export const POINTS_PER_PARTICIPATION = "10";
export const BREAK_DURATION_SEC = "60";
export const ROUND_DURATION_SEC = "900";
export const CHOOSING_CUTOFF_SEC = "300";
export const ROUND_ANCHOR_UTC_MIN = "15";
export const REVEAL_DURATION_SEC = "30";
export const LOOP_PAUSED = "true";